// components/Footer.js

import { Box, Text } from '@chakra-ui/react';

const Footer = () => (
  <Box as="footer" bg="gray.100" py={2} color="#282323" fontWeight={500} textAlign="center">
    <Text fontSize="sm">All Rights Reserved @2025</Text>
  </Box>
);

export default Footer;
